import { FC, useMemo } from "react";
// 常量
import { SelectTabTagsBaseProps, DEFAULT_FIELD_NAMES } from "../../interface";
import { getSelectTabOptions } from "../../util";

interface SelectTagsProps extends SelectTabTagsBaseProps {
}

const SelectTags: FC<SelectTagsProps> = props => {
  const { value, options, fieldNames, } = props;
  const labelHtml = useMemo(() => {
    const selectOptions = getSelectTabOptions(value, options, fieldNames);
    if (selectOptions && selectOptions.length) {
      return selectOptions[0]?.[fieldNames?.label || DEFAULT_FIELD_NAMES.label];
    }
    return null;
  }, [value, options, fieldNames]);
  return (
    <div className="yb-select-tab-tags">
      <span className="yb-select-tab-tags-item yb-line-ellipsis-1">
        {labelHtml}
      </span>
      {
        Array.isArray(value) && value.length > 1 && (
          <span className="yb-select-tab-tags-num">+{value.length - 1}</span>
        )
      }
    </div>
  );
};

export default SelectTags;
